<template>
  <div class="unsubscribe-preview" :style="{ backgroundColor }">
    <div class="msg-box">
      <div>
        <img v-if="logoUrl" :src="logoUrl" />
        <icon v-else class="default-icon" :glyph="`${type}-logo`" size="75" />
      </div>
      <h2>
        {{ $t('ProjectSettings_ChannelSettings_Preview_UnsubscribedTitle') }}
      </h2>
      <div class="text">
        <template v-if="type === 'email'">
          {{
            $t('ProjectSettings_ChannelSettings_Preview_Email_UnsubscribedText')
          }}
        </template>
        <template v-else>
          {{
            $t('ProjectSettings_ChannelSettings_Preview_Sms_UnsubscribedText')
          }}
        </template>
      </div>
      <div v-if="canManageSubscription">
        <rest-page>
          <rest-form
            :save-endpoint="{}"
            :after-save="null"
            :model="model"
            :rules="rules"
          >
            <rest-form-item
              v-if="type === 'email'"
              prop="email"
              :label="$t('ProjectSettings_ChannelSettings_Preview_Field_Email')"
            >
              <el-input
                type="email"
                :disabled="!allowChangeField"
                v-model="model.email"
              />
            </rest-form-item>
            <rest-form-item
              v-else
              prop="number"
              :label="
                $t('ProjectSettings_ChannelSettings_Preview_Field_Number')
              "
            >
              <el-input
                type="text"
                :disabled="!allowChangeField"
                v-model="model.number"
              />
            </rest-form-item>
            <rest-form-item
              prop="subscription"
              :label="
                $t('ProjectSettings_ChannelSettings_Preview_Field_Subscription')
              "
            >
              <el-select v-model="model.subscription">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                />
              </el-select>
            </rest-form-item>
            <el-button
              type="primary"
              :style="{
                backgroundColor: highlightColor,
                borderColor: highlightColor,
                color: buttonTextColor
              }"
            >
              {{ $t('ProjectSettings_ChannelSettings_Preview_SaveButton') }}
            </el-button>
          </rest-form>
        </rest-page>
      </div>
    </div>
  </div>
</template>

<script>
import RestFormItem from '@/common/components/rest/RestFormItem'
import RestPage from '@/common/components/rest/RestPage'
import RestForm from '@/common/components/rest/RestForm'
export default {
  name: 'UnsubscribePreview',
  components: { RestForm, RestPage, RestFormItem },
  data() {
    return {
      model: {
        email: 'user@xtremepush.com',
        number: '',
        subscription: 0
      },
      options: [
        {
          value: 0,
          label: this.$t('ProjectSettings_ChannelSettings_Preview_Unsubscribe')
        },
        {
          value: 1,
          label: this.$t('ProjectSettings_ChannelSettings_Preview_Subscribe')
        }
      ]
    }
  },
  props: {
    type: {
      type: String,
      default: 'email'
    },
    logoUrl: {
      type: String,
      default: null
    },
    backgroundColor: {
      type: String,
      default: '#2a2d32'
    },
    highlightColor: {
      type: String,
      default: '#46719E'
    },
    buttonTextColor: {
      type: String,
      default: '#ffffff;'
    },
    canManageSubscription: {
      type: Number,
      default: 0
    },
    allowChangeField: {
      type: Number,
      default: 0
    }
  },
  computed: {
    rules() {
      return {
        email: {
          required: true,
          type: 'email'
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.unsubscribe-preview {
  border: 1px solid #dbdee7;
  /deep/ .page {
    background-color: #ffffff;
  }
  padding: 60px;
  .msg-box {
    img {
      max-height: 100px;
      max-width: 100%;
    }
    .default-icon >>> svg {
      color: #1d87c8;
    }
    h2 {
      color: #333333;
      padding-top: 10px;
      padding-bottom: 15px;
    }
    .text {
      padding-bottom: 20px;
    }
    font-size: 16px;
    line-height: 24px;
    color: #595959;
    background: #ffffff;
    padding: 30px 64px;
    text-align: center;
  }
  .el-form-item {
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/settings/components/UnsubscribePreview.vue